import { Button, Dialog, DialogActions, TextArea } from '@wodi/ui';
import { useState } from 'react';

/**
 * Asks for a short text before a step (what was done, a closing note, a reason). The step
 * runs only when the text is at least `minLength` characters; the server checks it again.
 */
export function TextDialog({
  title,
  label,
  description,
  minLength = 1,
  maxLength = 2000,
  isOpen,
  onOpenChange,
  confirmLabel,
  pendingLabel,
  isPending,
  error,
  onConfirm,
}: {
  title: string;
  label: string;
  description?: string;
  minLength?: number;
  maxLength?: number;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  confirmLabel: string;
  pendingLabel: string;
  isPending: boolean;
  error: string | null;
  onConfirm: (text: string) => void;
}) {
  const [text, setText] = useState('');
  const [tried, setTried] = useState(false);
  const short = text.trim().length < minLength;
  return (
    <Dialog title={title} isOpen={isOpen} onOpenChange={onOpenChange}>
      <TextArea
        label={label}
        {...(description === undefined ? {} : { description })}
        value={text}
        onChange={setText}
        maxLength={maxLength}
        {...(tried && short
          ? {
              errorMessage:
                minLength > 1
                  ? `Write at least ${String(minLength)} characters.`
                  : 'Write something here first.',
            }
          : error === null
            ? {}
            : { errorMessage: error })}
      />
      <DialogActions>
        <Button
          variant="quiet"
          onPress={() => {
            onOpenChange(false);
          }}
        >
          Go back
        </Button>
        <Button
          variant="primary"
          isPending={isPending}
          pendingLabel={pendingLabel}
          onPress={() => {
            setTried(true);
            if (!short) onConfirm(text.trim());
          }}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
